<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Resumen</div>
      <div slot="sub-title">Estado Actual de la Escuela</div>
      <div slot="right">
        <filters :selected-lesson.sync="lessonSelect" :selected-from-date.sync="selectedFromDate" :selected-to-date.sync="selectedToDate"/>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns is-hidden-desktop">
        <div class="column">
          <dressage-level />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="columns is-multiline">
            <div class=" column is-12-mobile">
              <card-component title="Primeros 5 lugares" subtitle="Promedio evaluaciones en periodo" class="has-table has-mobile-sort-spaced">
                <ranking-table slot="content" :loading="isLoadingTop" :data="topRanking"/>
              </card-component>
            </div>
            <div class="div column is-12-mobile ">
              <card-component title="Últimos 5 lugares" subtitle="Promedio evaluaciones en periodo" class="has-table has-mobile-sort-spaced">
                <ranking-table slot="content" :loading="isLoadingWorst" :data="worstRanking"/>
              </card-component>
            </div>
          </div>
        </div>
        <div class="column is-3 is-hidden-mobile">
          <dressage-level />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RankingService from '@/services/RankingService'
import LessonService from '@/services/LessonService.js'
// import TrafficLight from './components/TrafficLight'

import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'
import Filters from '@/components/Filters'
import RankingTable from './components/RankingTable'
import DressageLevel from './components/DressageLevel'
import DashboardFilterService from '@/services/filters/DashboardFilterService'

export default {
  name: 'home',
  components: {
    HeroBar,
    RankingTable,
    CardComponent,
    Filters,
    DressageLevel
    // TrafficLight
  },
  created () {
    this.initFilters()
  },
  data () {
    return {
      lessonSelect: 0,
      selectedFromDate: null,
      selectedToDate: null,
      topRanking: [],
      worstRanking: [],
      isLoadingTop: false,
      isLoadingWorst: false
    }
  },
  methods: {
    initFilters () {
      let filters = DashboardFilterService.getFilters(this.$route.query)
      this.selectedFromDate = filters.from
      this.selectedToDate = filters.to
      this.lessonSelect = filters.lesson
      this.updateParams()
      this.getRanking()
    },
    getFormatedFilters () {
      let filters = {
        from: this.fromFormated,
        to: this.toFormated,
        lesson: this.lessonSelect
      }
      return filters
    },
    updateParams () {
      let formatedFilters = this.getFormatedFilters()
      DashboardFilterService.setStorageFilters(formatedFilters)
      // eslint-disable-next-line handle-callback-err
      this.$router.replace({ query: formatedFilters }).catch(err => {})
    },
    async getRanking () {
      this.isLoadingTop = true
      this.isLoadingWorst = true
      let response = await RankingService.getRanking({
        'lessons[0]': this.lessonSelect === 0 ? null : this.lessonSelect,
        'from': this.fromFormated,
        'to': this.toFormated,
        'active': 1
      })
      let data = response.data.data
      let lessonsResponse = await LessonService.getLessons()
      let lessons = lessonsResponse.data.data
      let firstData = []
      let secondData = []

      if (data.length <= 5) {
        firstData = data
        secondData = data
      } else {
        firstData = data.slice(0, 5)
        secondData = data.slice(Math.max(data.length - 5, 0))
      }

      this.extractTopRanking(lessons, firstData)
      this.extractWorstRanking(lessons, secondData.reverse())
    },
    extractWorstRanking (lessons, data) {
      this.worstRanking = data
      this.worstRanking.forEach(item => {
        if (item.lesson_status) {
          if (item.lesson_status === 'medium') {
            item['status'] = 'is-warning'
          } else if (item.lesson_status === 'high') {
            item['status'] = 'is-success'
          } else if (item.lesson_status === 'low') {
            item['status'] = 'is-danger'
          }
        }
      })
      this.isLoadingWorst = false
    },
    extractTopRanking (lessons, data) {
      this.topRanking = data
      this.topRanking.forEach(item => {
        if (item.lesson_status) {
          if (item.lesson_status === 'medium') {
            item['status'] = 'is-warning'
          } else if (item.lesson_status === 'high') {
            item['status'] = 'is-success'
          } else if (item.lesson_status === 'low') {
            item['status'] = 'is-danger'
          }
        }
      })
      this.isLoadingTop = false
    }
  },
  computed: {
    fromFormated () {
      return this.$moment(this.selectedFromDate).format('YYYY-MM-DD')
    },
    toFormated () {
      return this.$moment(this.selectedToDate).format('YYYY-MM-DD')
    }
  },
  watch: {
    lessonSelect (value) {
      this.updateParams()
      this.getRanking()
    },
    selectedFromDate (value) {
      this.updateParams()
      this.getRanking()
    },
    selectedToDate (value) {
      this.updateParams()
      this.getRanking()
    }
  }
}
</script>
